import {
  VITE_CONTROL_CENTER_BASE_URL,
  VITE_CONTROL_CENTER_FEATURES_BASE_URL,
  VITE_CONTROL_CENTER_WALLET_CTID,
} from './envConstants';

// control center image/assets path config
const CONTROL_CENTER_IMAGE_FOLDER = 'images';
export const CONTROL_CENTER_IMAGE_PATH = `${VITE_CONTROL_CENTER_BASE_URL}${CONTROL_CENTER_IMAGE_FOLDER}`;

// Feature file current active version
export const FEATURES_FILE_VERSION = '/v1.0/10/';

// Control center file names aka context paths
const CONTENT_FILE_CONTEXT = 'content.json';
const FEATURE_FILE_CONTEXT = 'config.json';
const TNC_FILE_CONTEXT = 'termsAndConditions.json';

// Full endpoint urls
export const CONTENT_ENDPOINT = `${VITE_CONTROL_CENTER_BASE_URL}${CONTENT_FILE_CONTEXT}`;
export const FEATURES_ENDPOINT = `${VITE_CONTROL_CENTER_FEATURES_BASE_URL}${VITE_CONTROL_CENTER_WALLET_CTID}${FEATURES_FILE_VERSION}${FEATURE_FILE_CONTEXT}`;
export const TNC_ENDPOINT = `${VITE_CONTROL_CENTER_BASE_URL}${TNC_FILE_CONTEXT}`;

// Add any new feature flags added to control center here with default value
export const CONTROL_CENTER_DEFAULT_FEATURE_FLAGS = {
  accessToAppleWallet: false,
  accessToGoogleWallet: false,
  accessToSamsungWallet: false,
  accessToVirtualCard: false,
  accessToSingleUseCard: false,
  accessToTempShoppingPass: false,
  accessToTokenizedShoppingPass: false,
  accessToCreditLimitIncrease: false,
  accessToLanguageToggle: false,
  accessToUiBarcode: false,
  accessToPlasticId: false,
};
